"use client";

import React, { useEffect } from "react";

export function Toast({
  message,
  kind = "success",
  onClose,
  durationMs = 2000,
}: {
  message: string;
  kind?: "success" | "error" | "info";
  onClose: () => void;
  durationMs?: number;
}) {
  useEffect(() => {
    const t = setTimeout(onClose, durationMs);
    return () => clearTimeout(t);
  }, [onClose, durationMs]);

  const cls =
    kind === "success"
      ? "border-green-200 bg-green-50 text-green-900"
      : kind === "error"
      ? "border-red-200 bg-red-50 text-red-900"
      : "border-gray-200 bg-gray-50 text-gray-900";

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className={`rounded-lg border px-3 py-2 text-xs shadow-sm ${cls}`}>
        <div className="flex items-start gap-3">
          <div className="flex-1">{message}</div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800"
            aria-label="Close toast"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
